



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { IWeOweConfigDealFee } from '@/models/filebunker/weowe';
import {storeService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class WeOweConfigPage extends Base {
  public weOweModel: IWeOweConfigDealFee = {};
  public form: any = {};
  public vm: any = '';
  public weOweConfigFields: Array<VFields<any>> = [
    {
      key: 'recordType',
      required: true,
      type: 'v-alynk-text-field',
      templateOptions: {
        disabled: false,
        label: this.$parent.$t(
          'stores.weOwe.weOweFields.dealFeeRecordType'
        ) as string,
        loading: false,
        rules:[
          v => this.required('Record Type',v)
        ]
      },
    },
    {
      key: 'sequenceNumber',
      required: true,
      type: 'v-alynk-text-field',
      templateOptions: {
        disabled: false,
        label: this.$parent.$t(
          'stores.weOwe.weOweFields.dealFeeSequenceNumber'
        ) as string,
        loading: false,
        rules:[
          v => this.required('Sequence Number',v)
        ]
      },
    },
  ];

  public storeId: number = 0;
  public weOweConfigId: string = '';
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'WeoweConfigs' },
        })
        .catch(() => {
          // catch Block
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.weOwe.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.submit();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    }
    this.weOweConfigId = this.$route.params.weOweConfigId;
    if (this.weOweConfigId) {
      this.getWeOweConfig();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public validateWeoweConfig(): Vue & { validate: () => boolean } {
    return this.$refs.weoweConfigForm as Vue & { validate: () => boolean };
  }


  public async submit(): Promise<void> {
    if(this.validateWeoweConfig().validate()){
      if (!this.weOweModel.recordType) {
        this.showAlert(
          false,
          this.$parent.$t('stores.weOwe.alertRecordTypeRequired')
        );
        return;
      }
      if (!this.weOweModel.sequenceNumber) {
        this.showAlert(
          false,
          this.$parent.$t('stores.weOwe.alertSequenceNumberIsRequired')
        );
        return;
      }
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.weOweConfigId) {
          await storeService.updateWeOweConfig(
            this.storeId,
            this.weOweModel
          );
          this.showAlert(true, this.$parent.$t('stores.weOwe.alertUpdated'));
        } else {
          await storeService.addWeOweConfig(this.storeId, this.weOweModel);
          this.showAlert(true, this.$parent.$t('stores.weOwe.alertSaved'));
        }
        this.$router
          .push({
            name: 'admin.stores.edit',
            params: {
              storeId: this.storeId.toString(),
              tab: 'WeoweConfigs'
            },
          })
          .catch(() => { // catch block
          });

      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getWeOweConfig(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.weOweConfigFields);
      this.weOweModel = {};
      const response = await storeService.getWeOweConfig(
        this.storeId,
        this.weOweConfigId
      );
      this.weOweModel = response;
    } finally {
      this.formlyHideSkeleton(this.weOweConfigFields);
    }
  }
}
